export default "__VITE_ASSET__CeXZjfje__"